import { initReactI18next } from 'react-i18next';

import { resources } from './resources';
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import { captureAsyncError } from '@/utils/captureAsyncError';

import { LanguageCode, LocalStorage } from '../enums';

const savedLanguage = localStorage.getItem(LocalStorage.LANGUAGE);

const getValidLanguage = (lang: string | null): LanguageCode => {
  const validLanguages = Object.values(LanguageCode);
  return lang && validLanguages.includes(lang as LanguageCode)
    ? (lang as LanguageCode)
    : LanguageCode.EN;
};

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    resources,
    fallbackLng: LanguageCode.EN,
    debug: false,
    ns: ['common', 'user', 'onboarding'],
    lng: getValidLanguage(savedLanguage),
    defaultNS: 'common',
    interpolation: {
      escapeValue: false,
    },
  })
  .catch(captureAsyncError);

export { i18n };
